/**
 * MAHOLA — Performance + UX/SEO + a11y fixes
 * Created: 2026-04-29
 * Updated: 2026-04-30 v3 (added .extra-name removal)
 * Updated: 2026-04-30 v4 (added empty alt for decorative images without alt)
 *
 * Four fixes :
 *
 * 1. King Linked Options : downgrade swatches loading=eager -> lazy.
 *    Reduces thumbnail.getalltool.com requests at first paint.
 *
 * 2. CLS preventer : add HTML width/height attrs to images that lack them,
 *    using CSS computed dimensions, BEFORE lazy-loaded images fetch.
 *
 * 3. Clean card titles : remove the .extra-name span injected by
 *    snippets/card-product.liquid which duplicates the color already
 *    present in the product name (ex. 'YAMA 7 STONE - STONE').
 *    Note 2026-04-30 : also fixed in card-product.liquid directly,
 *    this JS path remains as defense-in-depth for cached HTML.
 *
 * 4. Empty alt for decorative images : add alt="" to <img> tags that lack
 *    an alt attribute (decorative ellipses, placeholder main-image, etc.).
 *    Lighthouse a11y compliance + SEO best practice.
 *
 * All fixes are additive and safe to remove.
 */
(function () {
  'use strict';

  // ---------- Fix 1 : King Linked Options swatches ----------
  function downgradeKingSwatches() {
    var imgs = document.querySelectorAll(
      'king-linked-options-product img[loading="eager"], ' +
      '.lv-option-image-swatch img[loading="eager"]'
    );
    for (var i = 0; i < imgs.length; i++) {
      imgs[i].loading = 'lazy';
      imgs[i].decoding = 'async';
      imgs[i].setAttribute('fetchpriority', 'low');
    }
  }

  // ---------- Fix 2 : add width/height to images that lack them ----------
  function fixMissingDimensions() {
    var imgs = document.querySelectorAll('img:not([width]), img:not([height])');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.hasAttribute('width') && img.hasAttribute('height')) continue;
      if (!img.getAttribute('src') && !img.getAttribute('data-src')) continue;

      var rect = img.getBoundingClientRect();
      var w = Math.round(rect.width);
      var h = Math.round(rect.height);

      if (!w || !h) {
        var cs = window.getComputedStyle(img);
        w = parseInt(cs.width, 10) || img.naturalWidth || 24;
        h = parseInt(cs.height, 10) || img.naturalHeight || 24;
      }

      if (w > 0 && h > 0) {
        if (!img.hasAttribute('width')) img.setAttribute('width', w);
        if (!img.hasAttribute('height')) img.setAttribute('height', h);
      }
    }
  }

  // ---------- Fix 3 : remove .extra-name spans from product card titles ----------
  function removeExtraNameSpans() {
    var spans = document.querySelectorAll('.full-unstyled-link .extra-name, .card__heading .extra-name');
    for (var i = 0; i < spans.length; i++) {
      spans[i].remove();
    }
  }

  // ---------- Fix 4 : add empty alt to decorative <img> without alt ----------
  function addEmptyAlt() {
    var imgs = document.querySelectorAll('img:not([alt])');
    for (var i = 0; i < imgs.length; i++) {
      imgs[i].setAttribute('alt', '');
    }
  }

  function runAllFixes() {
    downgradeKingSwatches();
    fixMissingDimensions();
    removeExtraNameSpans();
    addEmptyAlt();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAllFixes);
  } else {
    runAllFixes();
  }

  // Re-apply when new content is injected dynamically (King swatches, Slick, AJAX collection filters, etc.)
  var observer = new MutationObserver(function () { runAllFixes(); });
  document.addEventListener('DOMContentLoaded', function () {
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();